import { Component, Inject, OnInit } from '@angular/core';
import { CameraServerService } from '../../camera-server.service';
import { ToastrService } from 'ngx-toastr';
import { SpinnerService } from 'src/app/components/spinner-component/spinner.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppConstants, ErrorMessageFormField, OUTPUT_TYPE_LIST } from 'src/app/shared/app-constants';

export const TYPES = [
  { id: 1, value: "ALARM", name: "ALARM" },
  { id: 2, value: "STROBE", name: "STROBE" },
]

export const COMPORT_NO = [
  { id: 1, name: "101", value: "101" },
  { id: 2, name: "102", value: "102" },
]

@Component({
  selector: 'app-outputs-details-dialog',
  templateUrl: './outputs-details-dialog.component.html',
  styleUrls: ['./outputs-details-dialog.component.scss']
,
  standalone: false
})
export class OutputsDetailsDialogComponent implements OnInit {

  deviceTypsData: any = OUTPUT_TYPE_LIST;
  typesData: any = TYPES;
  comportNoData: any = COMPORT_NO;

  outputInputForm: FormGroup = new FormGroup({});

  isAddButton: boolean = false;
  loading: boolean = false;
  isAddedData: boolean = false;
  headerName: string = '';
  editableOutputData: any = {};
  hidePassword: boolean = true;
  errorMessageFormField: any = ErrorMessageFormField;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<OutputsDetailsDialogComponent>,
    private camService: CameraServerService,
    private toastr: ToastrService,
    public spinner: SpinnerService,
    public dialog: MatDialog,
    private formBuilder: FormBuilder
  ) { }

  ngOnInit(): void {
    this.outputInputForm = this.formBuilder.group({
      potentialId: [sessionStorage.getItem("potentialId"), [Validators.required]],
      uniqueId: [''],
      deviceType: ['AXIS_HORN', [Validators.required]],
      type: ['ALARM', [Validators.required]],
      displayName: ['AxisHorn', [Validators.required]],
      // comportNumber: ['101', [Validators.required]],
      address: ['Pro-vigil', [Validators.required]],
      ip: ['', [Validators.required]],
      portNumber: [null, [Validators.required]],
      username: ['root', [Validators.required]],
      password: ['60056005', [Validators.required]],
      macAddress: ['', [Validators.required]],
    })
    const isAddOutputs = sessionStorage.getItem("isAddOutputs");
    if (isAddOutputs === 'true') {
      this.isAddButton = true;
      this.headerName = 'Add Outputs';
    } else {
      this.isAddButton = false;
      this.headerName = `Edit Outputs ${this.data?.deviceUniqueId}`;
      this.getDeviceByDeviceUniqueId(this.data && this.data?.deviceUniqueId);
    }
  }

  handleSelectDeviceType(event: any) {
    if (this.outputInputForm.value.deviceType === "AXIS_HORN" && this.outputInputForm.value.type === 'ALARM') {
      this.outputInputForm.controls['displayName']?.setValue('Speaker');
      this.outputInputForm.controls['username']?.setValue('root');
      this.outputInputForm.controls['password']?.setValue('60056005');
      this.outputInputForm.controls['portNumber']?.setValue(null);
    } else if (this.outputInputForm.value.deviceType === "X310" && this.outputInputForm.value.type === 'ALARM') {
      this.outputInputForm.controls['displayName']?.setValue('X-310-Alarm01');
      this.outputInputForm.controls['username']?.setValue('root');
      this.outputInputForm.controls['password']?.setValue('60056005');
      this.outputInputForm.controls['portNumber']?.setValue(null);
    } else if (this.outputInputForm.value.deviceType === "X310New" && this.outputInputForm.value.type === 'ALARM') {
      this.outputInputForm.controls['displayName']?.setValue('X-310-New-Alarm01');
      this.outputInputForm.controls['username']?.setValue('root');
      this.outputInputForm.controls['password']?.setValue('60056005');
      this.outputInputForm.controls['portNumber']?.setValue(null);
    } else if (this.outputInputForm.value.deviceType === "X410" && this.outputInputForm.value.type === 'ALARM') {
      this.outputInputForm.controls['displayName']?.setValue('X-410-Alarm01');
      this.outputInputForm.controls['username']?.setValue('root');
      this.outputInputForm.controls['password']?.setValue('60056005');
      this.outputInputForm.controls['portNumber']?.setValue(null);
    } else if ((this.outputInputForm.value.deviceType === "X310") && this.outputInputForm.value.type === 'STROBE') {
      this.outputInputForm.controls['displayName']?.setValue('X-310-Strobe');
      this.outputInputForm.controls['username']?.setValue('admin');
      this.outputInputForm.controls['password']?.setValue('60056005');
      this.outputInputForm.controls['portNumber']?.setValue(null);
    } else if (this.outputInputForm.value.deviceType === "X310New" && this.outputInputForm.value.type === 'STROBE') {
      this.outputInputForm.controls['displayName']?.setValue('X-310-New-Strobe');
      this.outputInputForm.controls['username']?.setValue('admin');
      this.outputInputForm.controls['password']?.setValue('60056005');
      this.outputInputForm.controls['portNumber']?.setValue(null);
    } else if (this.outputInputForm.value.deviceType === "X410" && this.outputInputForm.value.type === 'STROBE') {
      this.outputInputForm.controls['displayName']?.setValue('X-410-Strobe');
      this.outputInputForm.controls['username']?.setValue('admin');
      this.outputInputForm.controls['password']?.setValue('60056005');
      this.outputInputForm.controls['portNumber']?.setValue(null);
    } else if (this.outputInputForm.value.deviceType === "AXIS_D4100_E" && (this.outputInputForm.value.type === 'ALARM' || this.outputInputForm.value.type === 'STROBE')) {
      this.outputInputForm.controls['displayName']?.setValue('Strobe-Siren');
      this.outputInputForm.controls['username']?.setValue('admin');
      this.outputInputForm.controls['password']?.setValue('247Supp0rt');
      this.outputInputForm.controls['portNumber']?.setValue(2001);
    } else {
      this.outputInputForm.controls['displayName']?.setValue(`${this.outputInputForm.value.deviceType}-${event}`);
      this.outputInputForm.controls['username']?.setValue('admin');
      this.outputInputForm.controls['password']?.setValue(null);
      this.outputInputForm.controls['portNumber']?.setValue(null);
    }
  }

  handleSelectType(event: any) {
    if (this.outputInputForm.value.deviceType === "AXIS_HORN" && this.outputInputForm.value.type === 'ALARM') {
      this.outputInputForm.controls['displayName']?.setValue('Speaker');
      this.outputInputForm.controls['username']?.setValue('root');
      this.outputInputForm.controls['password']?.setValue('60056005');
      this.outputInputForm.controls['portNumber']?.setValue(null);
    } else if (this.outputInputForm.value.deviceType === "X310" && this.outputInputForm.value.type === 'ALARM') {
      this.outputInputForm.controls['displayName']?.setValue('X-310-Alarm01');
      this.outputInputForm.controls['username']?.setValue('root');
      this.outputInputForm.controls['password']?.setValue('60056005');
      this.outputInputForm.controls['portNumber']?.setValue(null);
    } else if (this.outputInputForm.value.deviceType === "X310New" && this.outputInputForm.value.type === 'ALARM') {
      this.outputInputForm.controls['displayName']?.setValue('X-310-New-Alarm01');
      this.outputInputForm.controls['username']?.setValue('root');
      this.outputInputForm.controls['password']?.setValue('60056005');
      this.outputInputForm.controls['portNumber']?.setValue(null);
    } else if (this.outputInputForm.value.deviceType === "X410" && this.outputInputForm.value.type === 'ALARM') {
      this.outputInputForm.controls['displayName']?.setValue('X-410-Alarm01');
      this.outputInputForm.controls['username']?.setValue('root');
      this.outputInputForm.controls['password']?.setValue('60056005');
      this.outputInputForm.controls['portNumber']?.setValue(null);
    } else if ((this.outputInputForm.value.deviceType === "X310") && this.outputInputForm.value.type === 'STROBE') {
      this.outputInputForm.controls['displayName']?.setValue('X-310-Strobe');
      this.outputInputForm.controls['username']?.setValue('admin');
      this.outputInputForm.controls['password']?.setValue('60056005');
      this.outputInputForm.controls['portNumber']?.setValue(null);
    } else if (this.outputInputForm.value.deviceType === "X310New" && this.outputInputForm.value.type === 'STROBE') {
      this.outputInputForm.controls['displayName']?.setValue('X-310-New-Strobe');
      this.outputInputForm.controls['username']?.setValue('admin');
      this.outputInputForm.controls['password']?.setValue('60056005');
      this.outputInputForm.controls['portNumber']?.setValue(null);
    } else if (this.outputInputForm.value.deviceType === "X410" && this.outputInputForm.value.type === 'STROBE') {
      this.outputInputForm.controls['displayName']?.setValue('X-410-Strobe');
      this.outputInputForm.controls['username']?.setValue('admin');
      this.outputInputForm.controls['password']?.setValue('60056005');
      this.outputInputForm.controls['portNumber']?.setValue(null);
    } else if (this.outputInputForm.value.deviceType === "AXIS_D4100_E" && (this.outputInputForm.value.type === 'ALARM' || this.outputInputForm.value.type === 'STROBE')) {
      this.outputInputForm.controls['displayName']?.setValue('Strobe-Siren');
      this.outputInputForm.controls['username']?.setValue('admin');
      this.outputInputForm.controls['password']?.setValue('247Supp0rt');
      this.outputInputForm.controls['portNumber']?.setValue(2001);
    } else {
      this.outputInputForm.controls['displayName']?.setValue(`${this.outputInputForm.value.deviceType}-${event}`);
      this.outputInputForm.controls['username']?.setValue('admin');
      this.outputInputForm.controls['password']?.setValue(null);
      this.outputInputForm.controls['portNumber']?.setValue(null);
    }
  }

  handleSelectComportNumber(event: any) { }

  /** Check validation while adding the output all field filled or not */
  isAddValidation() {
    if (this.outputInputForm.value.potentialId !== '' && this.outputInputForm.value.deviceType !== '' && this.outputInputForm.value.type !== '' &&
      this.outputInputForm.value.displayName !== '' && this.outputInputForm.value.comport !== '' &&
      this.outputInputForm.value.ip !== '' && this.outputInputForm.value.portno !== '' && this.outputInputForm.value.username !== ''
      && this.outputInputForm.value.password !== '' && this.outputInputForm.value.macAddress !== '') {
      return true;
    } else {
      return false;
    }
  }


  /** This methods is used for adding Outputs */
  addOutputs() {
    const payloads: any = {
      potentialId: this.outputInputForm.value.potentialId,
      deviceType: this.outputInputForm.value.deviceType,
      type: this.outputInputForm.value.type,
      displayName: this.outputInputForm.value.displayName,
      // comport: parseInt(this.outputInputForm.value.comportNumber),
      address: this.outputInputForm.value.address,
      ip: this.outputInputForm.value.ip,
      portno: parseInt(this.outputInputForm.value.portNumber),
      username: this.outputInputForm.value.username,
      password: this.outputInputForm.value.password,
      macAddress: this.outputInputForm.value.macAddress
    }
    if (this.outputInputForm.valid) {
      this.spinner.activate();
      this.loading = true;
      this.camService.addDevices(payloads, "OUTPUT_DATA").subscribe((response: any) => {
        if (response && response.success) {
          this.spinner.deactivate();
          this.loading = false;
          this.toastr.success(response?.data?.message || "Device data is saved successfully.");
          this.dialogRef.close();
          this.isAddedData = true;
        } else {
          this.spinner.deactivate();
          this.loading = false;
          this.toastr.warning("Please try after some times");
          this.isAddedData = false;
        }
      }, (err) => {
        if (err) {
          this.spinner.deactivate();
          this.loading = false;
          this.toastr.error(AppConstants.defaultErrorMessage, 'Error');
        }
      })
    } else {
      this.toastr.error(AppConstants.mandatoryFieldMsg);
    }
  }

  /** This methods is used for getting devices by unique ID */
  getDeviceByDeviceUniqueId(deviceUniqueId: string) {
    this.spinner.activate();
    this.loading = true;
    if (deviceUniqueId) {
      this.camService.getDeviceByDeviceUID(deviceUniqueId).subscribe((response: any) => {
        if (response && response.success) {
          this.editableOutputData = response?.data;
          this.outputInputForm = this.formBuilder.group({
            potentialId: response?.data?.device?.potentialId,
            uniqueId: response?.data?.device?.deviceUniqueId,
            deviceType: response?.data?.device?.outputData?.deviceType,
            type: response?.data?.device?.outputData?.type,
            displayName: response?.data?.device?.outputData?.displayName,
            // comportNumber: response?.data?.device?.outputData?.comport,
            address: response?.data?.device?.outputData?.address,
            ip: response?.data?.device?.outputData?.ip,
            portNumber: response?.data?.device?.outputData?.portno,
            username: response?.data?.device?.outputData?.username,
            password: response?.data?.device?.outputData?.password,
            macAddress: response?.data?.device?.outputData?.macAddress,
          })
          this.spinner.deactivate();
          this.loading = false;

        } else {
          this.spinner.deactivate();
          this.loading = false;
          this.toastr.warning(response.message || AppConstants.defaultErrorMessage);
        }
      }, (err) => {
        this.loading = false;
        this.spinner.deactivate();
        if (err && err.error && err.error.message && err.error.message.length > 0) {
          this.toastr.error(err.error.message, 'Error');
        } else {
          this.toastr.error('Session Expired Please login again.', 'Error');
        }
      })
    }
  }

  /** This methods is used for Updating the outputs*/
  updateOutputs() {
    const payloads: any = {
      deviceUniqueId: this.data?.deviceUniqueId,
      potentialId: this.data?.potentialId,
      deviceType: this.outputInputForm.value.deviceType,
      type: this.outputInputForm.value.type,
      displayName: this.outputInputForm.value.displayName,
      // comport: parseInt(this.outputInputForm.value.comportNumber),
      address: this.outputInputForm.value.address,
      ip: this.outputInputForm.value.ip,
      portno: parseInt(this.outputInputForm.value.portNumber),
      username: this.outputInputForm.value.username,
      password: this.outputInputForm.value.password,
      macAddress: this.outputInputForm.value.macAddress
    }
    if (this.isAddValidation()) {
      this.spinner.activate();
      this.loading = true;
      this.camService.updateDevices(payloads, "OUTPUT_DATA").subscribe((response: any) => {
        if (response && response.success) {
          this.spinner.deactivate();
          this.loading = false;
          this.toastr.success(response?.data?.message || "Device data is updated successfully.");
          this.dialogRef.close();
          // this.isAddedData = true;
        } else {
          this.spinner.deactivate();
          this.loading = false;
          this.toastr.warning("Please try after some times");
          // this.isAddedData = false;
        }
      }, (err) => {
        if (err) {
          this.spinner.deactivate();
          this.loading = false;
          this.toastr.error(AppConstants.defaultErrorMessage, 'Error');
        }
      })
    } else {
      // this.isAddedData = false;
      this.toastr.error(AppConstants.mandatoryFieldMsg);
    }
  }

}
